

const publicRoute = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/page/login/index.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/page/404/index.vue')
    },
];

export default publicRoute;
